import React from "react";
import QualificationSelection from "./qualification/QualificationSection";
import ContractDurationSection from "./contractDuration/ContractDurationSection";

const RecruitmentConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-container'>
      <QualificationSelection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <ContractDurationSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
    </div>
  );
};

export default RecruitmentConfigSection;
